module.exports = __webpack_public_path__ + "2.png?cc79f57f7c6dbf797e1ec046c0649e72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartoon/2.png
// module id = 206
// module chunks = 0